import { BackgroundIcon, Box } from "@prismicio/editor-ui"

interface LegacySlicePreviewProps {
  selected?: boolean
}

export function LegacySlicePreview(props: LegacySlicePreviewProps) {
  const { selected = false } = props

  return (
    <Box justifyContent="center" padding={{ block: 24 }}>
      <BackgroundIcon
        color={selected ? "purple" : "grey"}
        name="viewDay"
        size="large"
      />
    </Box>
  )
}
